import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "uf-auth-detail" }
const _hoisted_2 = { class: "uf-auth-detail__header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "uf-auth-detail__header-status" }
const _hoisted_5 = { class: "uf-auth-detail__header-message" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "uf-title" }, "申请详情", -1)
const _hoisted_7 = { class: "uf-auth-detail__group" }
const _hoisted_8 = { class: "uf-auth-detail__item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "uf-title2" }, "机构信息", -1)
const _hoisted_10 = { class: "uf-auth-detail__item" }
const _hoisted_11 = { class: "uf-auth-detail__item" }
const _hoisted_12 = { class: "uf-auth-detail__item" }
const _hoisted_13 = { class: "uf-auth-detail__item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "uf-auth-detail__item" }, "营业执照：", -1)
const _hoisted_15 = { class: "uf-uploader__preview" }
const _hoisted_16 = { class: "uf-uploader__preview-image" }
const _hoisted_17 = { class: "uf-uploader__preview-content" }
const _hoisted_18 = { class: "uf-uploader__preview-content-title" }
const _hoisted_19 = { class: "uf-uploader__preview-content-size" }
const _hoisted_20 = { class: "uf-auth-detail__item" }
const _hoisted_21 = { class: "uf-auth-detail__item" }
const _hoisted_22 = { class: "uf-auth-detail__item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "uf-title2" }, "人员信息", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "uf-title2" }, "供应商信息", -1)
const _hoisted_25 = { class: "uf-auth-detail__item" }
const _hoisted_26 = { class: "uf-auth-detail__item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "uf-auth-detail__item" }, "营业执照：", -1)
const _hoisted_28 = { class: "uf-uploader__preview" }
const _hoisted_29 = { class: "uf-uploader__preview-image" }
const _hoisted_30 = { class: "uf-uploader__preview-content" }
const _hoisted_31 = { class: "uf-uploader__preview-content-title" }
const _hoisted_32 = { class: "uf-uploader__preview-content-size" }
const _hoisted_33 = { class: "uf-auth-detail__item" }
const _hoisted_34 = { class: "uf-auth-detail__item" }
const _hoisted_35 = { class: "uf-auth-detail__item" }
const _hoisted_36 = { class: "uf-auth-detail__item" }
const _hoisted_37 = { class: "uf-auth-detail__item" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "uf-title2" }, "人员信息", -1)
const _hoisted_39 = { class: "uf-auth-detail__item" }
const _hoisted_40 = { class: "uf-auth-detail__item" }
const _hoisted_41 = { class: "uf-auth-detail__item" }
const _hoisted_42 = {
  key: 2,
  class: "uf-auth-detail__item"
}
const _hoisted_43 = {
  key: 3,
  class: "uf-auth-detail__item"
}
const _hoisted_44 = {
  key: 4,
  class: "uf-auth-detail__item"
}
const _hoisted_45 = {
  key: 5,
  class: "uf-auth-detail__item"
}
const _hoisted_46 = {
  key: 6,
  class: "uf-auth-detail__item"
}
const _hoisted_47 = { class: "uf-auth-detail__item" }
const _hoisted_48 = { class: "uf-auth-detail__item" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "uf-auth-detail__item" }, "身份证照片：", -1)
const _hoisted_50 = { class: "uf-auth-detail__idcard-images" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "uf-auth-detail__item",
  style: {"margin-top":"10px"}
}, " 资格证： ", -1)
const _hoisted_52 = { class: "uf-uploader__preview-image" }
const _hoisted_53 = { class: "uf-uploader__preview-content" }
const _hoisted_54 = { class: "uf-uploader__preview-content-title" }
const _hoisted_55 = { class: "uf-uploader__preview-content-size" }
const _hoisted_56 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.headerImg,
          class: "uf-auth-detail__header-img",
          alt: ""
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.detail.state_name), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.headerMessage), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, "申请身份：" + _toDisplayString(_ctx.detail.type_name), 1),
        (_ctx.detailType === 'Stores')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, " 客户机构名称：" + _toDisplayString(_ctx.detail.stores_name) + " 机构类型：" + _toDisplayString(_ctx.detail.stores_type_name), 1),
              _createElementVNode("div", _hoisted_11, "属性：" + _toDisplayString(_ctx.detail.stores_sub_name), 1),
              _createElementVNode("div", _hoisted_12, "位置：" + _toDisplayString(_ctx.detail.place_name), 1),
              _createElementVNode("div", _hoisted_13, "统一社会信用代码：" + _toDisplayString(_ctx.detail.social_credit), 1),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_van_icon, { name: "column" })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.detail.license_array.file_name), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.detail.license_array.file_size) + "KB", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, " 营业期限：" + _toDisplayString(_ctx.detail.license_start_time_name) + " - " + _toDisplayString(_ctx.detail.license_end_time_name), 1),
              _createElementVNode("div", _hoisted_21, "法人/业主：" + _toDisplayString(_ctx.detail.owner_name), 1),
              _createElementVNode("div", _hoisted_22, "联系电话：" + _toDisplayString(_ctx.detail.contact_phone), 1),
              _hoisted_23
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.detailType === 'Factory')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, "供应商名称：" + _toDisplayString(_ctx.detail.factory_name), 1),
              _createElementVNode("div", _hoisted_26, "统一社会信用代码：" + _toDisplayString(_ctx.detail.social_credit), 1),
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_van_icon, { name: "column" })
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.detail.license_array.file_name), 1),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.detail.license_array.file_size) + "KB", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_33, " 营业期限：" + _toDisplayString(_ctx.detail.license_start_time_name) + " - " + _toDisplayString(_ctx.detail.license_end_time_name), 1),
              _createElementVNode("div", _hoisted_34, " 公司所在地： " + _toDisplayString(_ctx.detail.province_detail.name) + " " + _toDisplayString(_ctx.detail.city_array.name) + " " + _toDisplayString(_ctx.detail.county_detail.name), 1),
              _createElementVNode("div", _hoisted_35, "详细地址：" + _toDisplayString(_ctx.detail.address), 1),
              _createElementVNode("div", _hoisted_36, "联系人：" + _toDisplayString(_ctx.detail.contact_name), 1),
              _createElementVNode("div", _hoisted_37, "联系电话：" + _toDisplayString(_ctx.detail.contact_phone), 1),
              _hoisted_38
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_39, "姓名：" + _toDisplayString(_ctx.detail.name), 1),
        _createElementVNode("div", _hoisted_40, "性别：" + _toDisplayString(_ctx.detail.gender_name), 1),
        _createElementVNode("div", _hoisted_41, "手机号：" + _toDisplayString(_ctx.detail.mobile), 1),
        (_ctx.detailType === 'Residence')
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, "房间：" + _toDisplayString(_ctx.detail.house_numbers), 1))
          : _createCommentVNode("", true),
        (_ctx.detailType !== 'Residence')
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, "邮箱：" + _toDisplayString(_ctx.detail.email), 1))
          : _createCommentVNode("", true),
        (_ctx.detailType === 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, "部门：" + _toDisplayString(_ctx.detail.department_name), 1))
          : _createCommentVNode("", true),
        (_ctx.detailType !== 'Factory' && _ctx.detailType !== 'Residence')
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, " 职务：" + _toDisplayString(_ctx.detail.duty_name), 1))
          : _createCommentVNode("", true),
        (_ctx.detailType === 'Staff')
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, "专业：" + _toDisplayString(_ctx.detail.subgroup_name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_47, "身份证号：" + _toDisplayString(_ctx.detail.id_card), 1),
        _createElementVNode("div", _hoisted_48, "身份证有效期：" + _toDisplayString(_ctx.detail.start_time_name) + " - " + _toDisplayString(_ctx.detail.end_time_name), 1),
        _hoisted_49,
        _createElementVNode("div", _hoisted_50, [
          (_ctx.detail.positive_array.photo_file)
            ? (_openBlock(), _createBlock(_component_van_image, {
                key: 0,
                class: "uf-auth-detail__idcard-image",
                height: "105px",
                fit: "contain",
                src: _ctx.detail.positive_array.photo_thumb_file,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ImagePreview([_ctx.detail.positive_array.photo_file])))
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (_ctx.detail.back_array.photo_file)
            ? (_openBlock(), _createBlock(_component_van_image, {
                key: 1,
                class: "uf-auth-detail__idcard-image",
                height: "105px",
                fit: "contain",
                src: _ctx.detail.back_array.photo_thumb_file,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ImagePreview([_ctx.detail.back_array.photo_file])))
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.detailType !== 'Stores' && _ctx.detailType !== 'Residence')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _hoisted_51,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.certificate, (certificate) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "uf-uploader__preview",
                  key: certificate.photo_id
                }, [
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_van_icon, { name: "column" })
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, _toDisplayString(certificate.photo_id_array.file_name), 1),
                    _createElementVNode("div", _hoisted_55, _toDisplayString(certificate.photo_id_array.file_size) + "KB", 1)
                  ])
                ]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createVNode(_component_van_button, {
        onClick: _ctx.cancelApply,
        block: "",
        color: "#3d6eeb",
        square: "",
        type: "success"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.detail.state == 2 ? "取消申请" : "重新申请"), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}